import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { Clear } from "@mui/icons-material";

type IconButtonProps = {
  icon: JSX.Element;
  label: string;
  clickFunction?: () => void;
  color?: string;
  disabled?: boolean;
};

export default function MyIconButton(props: IconButtonProps) {
  const { icon, label, clickFunction, color = "primary.main", disabled } = props;

  return (
    <Button
      sx={{
        textTransform: "none",
        padding: 0.25,
        border: "1px solid transparent",
        color: color,
        // ":hover": {
        //   border: "1px solid",
        // },
      }}
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        clickFunction && clickFunction();
      }}
      disabled={disabled}
    >
      <Stack direction={"column"} alignItems={"center"} justifyContent={"center"}>
        {icon}
        <Typography variant="label_S">{label}</Typography>
      </Stack>
    </Button>
  );
}

export function ClearButton(props: {
  onClick: Function;

  disabled?: boolean;
}) {
  return (
    <Button
      variant="text"
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        props.onClick();
        // handleDelete(index);
      }}
      sx={{
        width: "32px",
        aspectRatio: "1 / 1",
        minWidth: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
      }}
      disabled={props.disabled}
    >
      <Clear />
    </Button>
  );
}
